import i18next from 'i18next';
import { toast } from 'react-toastify';

let openFile: (fileName: string, file: Blob) => Promise<void>;

export type Result =
  | {
      type: 'error';
      error: string;
    }
  | {
      type: 'success';
    }
  | {
      type: 'cancel';
    };

export function setOpenFile(
  openFileFunction: (fileName: string, file: Blob) => Promise<void>,
): void {
  openFile = openFileFunction;
}

export async function downloadAndOpenFile(
  fileName: string,
  file: Blob,
): Promise<void> {
  return await openFile?.(fileName, file);
}

let saveAs: (fileName: string, file: Blob) => Promise<void>;

export function setSaveAsFile(
  saveAsFileFunction: (fileName: string, file: Blob) => Promise<void>,
): void {
  saveAs = saveAsFileFunction;
}

export async function saveAsFile(fileName: string, file: Blob): Promise<void> {
  return await saveAs?.(fileName, file);
}

let collectLogsFunction: () => Promise<void>;

export function setCollectLogs(collectLogs: () => Promise<Result>): void {
  collectLogsFunction = async () => {
    const result = await collectLogs();
    if (result.type === 'success') {
      toast(
        i18next.t('toolbar.user_profile.toasts.collect_logs_successfully'),
        {
          type: 'success',
        },
      );
    } else if (result.type === 'error') {
      const errorMessage =
        result.error ?? i18next.t('toolbar.user_profile.toasts.unknown_error');
      toast(
        i18next.t('toolbar.user_profile.toasts.collect_logs_error', {
          error: i18next.t(errorMessage as any),
        }),
        {
          type: 'error',
        },
      );
    }
  };
}

export async function collectLogs(): Promise<void> {
  return await collectLogsFunction?.();
}

let selectFolderFunc: () => Promise<string>;

export function setSelectFolder(
  selectFolderFunction: () => Promise<string>,
): void {
  selectFolderFunc = selectFolderFunction;
}

export async function selectFolder(): Promise<string> {
  return await selectFolderFunc?.();
}
